import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

type PropsType = SVGComponentPropsType & {
  title?: string;
};

export default ({ color = defaultIconColor, size = defaultSize, title, ...props }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${defaultSize} ${defaultSize}`}
      height={`${size}`}
      width={`${size}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
        <path d="M9 4v16M15 4v16M4 15h16M4 9h16" />
      </g>
    </svg>
  );
};
